__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@hopin-team/application-schedule-widget";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@slicesjs/core", "2.3.0", () => (__webpack_require__.e(463).then(() => (() => (__webpack_require__(7463))))));
			register("@slicesjs/react-core", "2.4.0", () => (Promise.all([__webpack_require__.e(728), __webpack_require__.e(298), __webpack_require__.e(80), __webpack_require__.e(852)]).then(() => (() => (__webpack_require__(5852))))));
			register("@slicesjs/react-router-app", "2.3.0", () => (Promise.all([__webpack_require__.e(990), __webpack_require__.e(728), __webpack_require__.e(298), __webpack_require__.e(232), __webpack_require__.e(340), __webpack_require__.e(905)]).then(() => (() => (__webpack_require__(2905))))));
			register("@slicesjs/reactive-map", "1.0.13", () => (__webpack_require__.e(924).then(() => (() => (__webpack_require__(8924))))));
			register("polished", "4.2.2", () => (Promise.all([__webpack_require__.e(288), __webpack_require__.e(177)]).then(() => (() => (__webpack_require__(3288))))));
			register("react-dom", "18.1.0", () => (Promise.all([__webpack_require__.e(511), __webpack_require__.e(728)]).then(() => (() => (__webpack_require__(5511))))));
			register("react-router-dom", "6.3.0", () => (Promise.all([__webpack_require__.e(990), __webpack_require__.e(292), __webpack_require__.e(728)]).then(() => (() => (__webpack_require__(7292))))));
			register("react", "18.1.0", () => (__webpack_require__.e(921).then(() => (() => (__webpack_require__(921))))));
			register("styled-components", "5.0.0", () => (Promise.all([__webpack_require__.e(471), __webpack_require__.e(728)]).then(() => (() => (__webpack_require__(9471))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};